import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { injectModels } from "../../../redux/injectModels";
import { AuthService, EventService } from "../../../services";
import { AdminTransactionsService } from "../../../services";
import { toast } from "react-toastify";
import {
  formatAmount,
  formatDateENGB,
  handleConsoleError,
} from "../../../utils/common-methods";
import { Link } from "react-router-dom";
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import AutoCompleteDropdown from "../../../components/Common/AutoCompleteDropdown";
import { PaymentStatus } from "../../../constants/Enum";

const FinancialTransactionReports = (props) => {
  const [currentPage, setCurrentPage] = useState(0);
  const loginUser = AuthService.getLoginUser();
  const [suggestions, setSuggestions] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [showModal, setShow] = useState(false);
  const [activePayment, setActivePayment] = useState(null);
  //const [paginatedData, setPaginatedData] = useState([]);
  const [eventSearchName, setEventSearchName] = useState("All");

  const rowsPerPage = 10;
  const offset = currentPage * rowsPerPage;
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    const bootstrapAsync = async () => {
      await getEventData();
      await getAllOrganizerData(eventSearchName);
    };
    bootstrapAsync();
  }, []);

  const getEventData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const res = await EventService.getEventsByUserId(loginUser?.id);
        if (res?.isSuccess && res?.data?.length > 0) {
          const eventList = res?.data?.map((item) => ({
            eventName: item.eventName,
            id: item.id,
          }));
          setEventList(eventList);
          setSuggestions(eventList.map((item) => item.eventName));
        }
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  //  Transactions OrganizerPayment Report
  const getAllOrganizerData = async (id) => {
    props.application.setLoading(true);
    const userId = loginUser?.id;
    let eventId = "00000000-0000-0000-0000-000000000000";
    if (id && id.length > 5) {
      eventId = id;
    } else {
      // handleSelect("");
    }
    try {
      const res = await AdminTransactionsService.getAllOrganizerPaymentReports(
        userId,
        eventId
      );
      if (res?.isSuccess) {
        setFilteredData(res?.data);
        // setPaginatedData(res?.data.slice(offset, offset + rowsPerPage));
      }
      // else{
      //   toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      // }

      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleSelect = async (selected) => {
    if (selected && selected.length >= 2) {
      setEventSearchName(selected);
      const filetEvent = eventList.filter(
        (item) => item.eventName.trim() === selected.trim()
      );
      if (filetEvent.length > 0) {
        await getAllOrganizerData(filetEvent[0]?.id);
      }
    } else {
      //setSelectedValue("");
      //await getAllOrganizerData("");
      // setFilteredData([]);
      // setPaginatedData([]);
      setEventSearchName("All");
      await getAllOrganizerData("All");
    }
  };

  const getATV = () => {
    const totalAmount = filteredData?.reduce(
      (sum, item) =>
        sum +
        (item?.request?.amount || 0) +
        (item?.request?.applicationFeeAmount > 0
          ? Number(item?.request?.applicationFeeAmount)
          : 0),
      0
    );

    return " £ " + formatAmount(totalAmount / filteredData?.length);
  };

  const getObscuredTextLabel = (isApproved, text) => {
    return isApproved ? text : "*************";
  };

  const getObscuredText = (isApproved) => {
    return isApproved ? {} : { filter: "blur(8px)" };
  };

  return (
    <React.Fragment>
      <section>
        <section className="subscription-banner p-0">
          <div className="container">
            <h3> Application Transactions</h3>
          </div>
        </section>

        <section className="edit-form-table">
          <div className="container">
            <div className="mb-3">
              <div className="row">
                <div className="col-sm-12">
                  <span>Please enter event name</span>
                  <AutoCompleteDropdown
                    suggestions={suggestions}
                    onSelect={handleSelect}
                  />
                </div>
                {/* <div className="col-sm-2">
                        <Button onClick={handleSearch}>Search</Button>
                      </div> */}
              </div>
              {paginatedData?.length > 0 && (
                <div className="row mt-3">
                  <div className="col-sm-12">
                    <p>
                      <strong> Average Transaction Value:</strong> {getATV()}
                    </p>
                  </div>
                </div>
              )}
            </div>
            {eventSearchName && (
              <React.Fragment>
                <div className="table-responsive">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Transaction Id</th>
                        {/* <th>Event Name</th> */}
                        <th>Sender</th>
                        <th>Amount (£)</th>
                        {/* <th>Currency </th> */}
                        <th>Created On</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData && paginatedData.length > 0 ? (
                        <React.Fragment>
                          {paginatedData.map((item, idx) => {
                            return (
                              <tr key={idx}>
                                <td>{calculateSNo(idx)}</td>
                                <td>{item.response?.id}</td>
                                {/* <td>{item.eventName}</td> */}
                                <td
                                  style={getObscuredText(
                                    item?.status === PaymentStatus.Paid
                                  )}
                                >
                                  <h5 style={{ marginBottom: 0 }}>
                                    {getObscuredTextLabel(
                                      item?.status === PaymentStatus.Paid,
                                      item.sender?.businessName
                                    )}
                                  </h5>
                                  <h5>
                                    {getObscuredTextLabel(
                                      item?.status === PaymentStatus.Paid,
                                      item.sender?.email
                                    )}
                                  </h5>
                                </td>

                                {/* <td>£{formatAmount(item.response?.amount)}</td> */}
                                <td>
                                  £
                                  {formatAmount(
                                    item?.request?.amount +
                                      (item?.request?.applicationFeeAmount > 0
                                        ? item?.request?.applicationFeeAmount
                                        : 0)
                                  )}
                                </td>
                                {/* <td>{item.response?.currency}</td> */}
                                <td>{formatDateENGB(item?.createdOn)}</td>

                                <td
                                  className="delete-create"
                                  style={{ textAlign: "center" }}
                                >
                                  {item?.status === PaymentStatus.Paid ? (
                                    <i className="ri-check-fill"></i>
                                  ) : item?.status === PaymentStatus.Unpaid ? (
                                    <i className="fa-regular fa-clock"></i>
                                  ) : (
                                    <i className="ri-close-circle-line"></i>
                                  )}
                                </td>
                                <td>
                                  <div className="delete-create">
                                    <Link
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setActivePayment(item);
                                        setShow(true);
                                      }}
                                      style={{ marginRight: "10px" }}
                                    >
                                      <i className="fa-solid fa-eye"></i>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </React.Fragment>
                      ) : (
                        <tr>
                          <td colSpan="10 mt-2">No results found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                <div className="table-footer">
                  <p className="mb-3">
                    <strong>Total Count: {filteredData.length}</strong>
                  </p>
                  {filteredData.length === 0 ? "" : renderPagination()}
                </div>
              </React.Fragment>
            )}
            {!eventSearchName && (
              <p>
                Find the application transaction by entering the event name.
              </p>
            )}
          </div>
        </section>

        <Modal
          show={showModal}
          onHide={handleClose}
          backdrop="static"
          size="lg"
          centered
        >
          <Modal.Header closeButton className="modal-main-header">
            <Modal.Title>Payment details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form aria-disabled="true" style={{ flex: 1 }}>
              <fieldset disabled>
                <Row className="mb-3">
                  <Form.Group>
                    <Form.Label>{activePayment?.response?.payment_method_types.length > 0
                        ? activePayment.response?.payment_method_types[0]==="bank"?"Bank Payment":"Stripe transaction id"
                        : "Stripe transaction id"}</Form.Label>
                    <Form.Control defaultValue={activePayment?.response?.id} />
                  </Form.Group>
                </Row>

                <Form.Group controlId="formGridPassword">
                  <Form.Label>Sender</Form.Label>
                  <Form.Control
                    style={getObscuredText(
                      activePayment?.status === PaymentStatus.Paid
                    )}
                    defaultValue={getObscuredTextLabel(
                      activePayment?.status === PaymentStatus.Paid,
                      activePayment?.sender?.businessName
                    )}
                  />
                  <Form.Control
                    style={getObscuredText(
                      activePayment?.status === PaymentStatus.Paid
                    )}
                    defaultValue={getObscuredTextLabel(
                      activePayment?.status === PaymentStatus.Paid,
                      activePayment?.sender?.email
                    )}
                  />
                </Form.Group>
                {/* <Form.Group>
                <Form.Label>Receiver</Form.Label>
                <Form.Control
                  defaultValue={activePayment?.receiver?.businessName}
                />
                <Form.Control defaultValue={activePayment?.receiver?.email} />
              </Form.Group> */}

                <Form.Group>
                  <Form.Label>Receiver account</Form.Label>
                  <Form.Control
                    defaultValue={activePayment?.connectedAccount}
                  />
                </Form.Group>

                <Row className="mb-3">
                  <Form.Group as={Col}>
                    <Form.Label>Amount</Form.Label>
                    <Form.Control
                      defaultValue={"£" + formatAmount(activePayment?.amount)}
                    />
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label>Remaining amount</Form.Label>
                    <Form.Control
                      defaultValue={
                        "£" + formatAmount(activePayment?.remainingAmount)
                      }
                    />
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} controlId="formGridAddress1">
                    <Form.Label>Application Fee</Form.Label>
                    <Form.Control
                      defaultValue={
                        "£" + formatAmount(activePayment?.applicationFee)
                      }
                    />
                  </Form.Group>
                  <Form.Group as={Col} controlId="formGridAddress1">
                    <Form.Label>Payment part</Form.Label>
                    <Form.Control defaultValue={activePayment?.partPaymentNo} />
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col} controlId="formGridAddress1">
                    <Form.Label>Currency</Form.Label>
                    <Form.Control
                      defaultValue={activePayment?.response?.currency}
                    />
                  </Form.Group>

                  <Form.Group as={Col} controlId="formGridAddress1">
                    <Form.Label>Payment method</Form.Label>
                    <Form.Control
                      defaultValue={
                        activePayment?.response?.payment_method_types.length > 0
                          ? activePayment.response?.payment_method_types[0]
                          : "unknown"
                      }
                    />
                  </Form.Group>
                </Row>
                <Form.Group controlId="formGridStatus">
                  <Form.Label>Payment status</Form.Label>
                  <Form.Control
                    defaultValue={
                      activePayment?.status === PaymentStatus.Paid
                        ? "Paid"
                        : activePayment?.status === PaymentStatus.Canceled
                        ? "Cancelled"
                        : "Unpaid"
                    }
                  />
                </Form.Group>

                <Form.Group controlId="formGridStatus">
                  <Form.Label>Payment date</Form.Label>
                  <Form.Control
                    defaultValue={formatDateENGB(activePayment?.createdOn)}
                  />
                </Form.Group>
              </fieldset>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(FinancialTransactionReports);
